module.exports = __webpack_public_path__ + "img/craftBannerFences.f466b39.webp";